const initialState = {
  modalId: '',
  modalData: {}
};

export default function modal (state = initialState, action) {
  const { modalId, type, modalData } = action;

  if ('TOGGLE_MODAL' === type) {
    return { ...state, modalId, modalData };
  }

  return state;
}
